module.exports = __webpack_public_path__ + "img/maximilian-block.2f552f9e.jpg";